<template>
  <div>
    <div style="position: relative;">
      <h2 class="text-center font-weight-light">
        Quan trắc Môi trường
      </h2>
      <!-- <v-btn 
        :href="config.envUrl" 
        target="_blank"
        class="env-btn-link"
        color="primary"
        text
      >
        <span v-if="$vuetify.breakpoint.lgAndUp">Trang chủ Quan trắc</span>
      </v-btn> -->
      <v-chip 
        :href="config.envUrl"
        target="_blank"
        class="env-btn-link"
        :class="$vuetify.breakpoint.lgAndUp ? '' : 'agrimap-type-mob'"
      >
        <v-icon left>
          mdi-web
        </v-icon>
        Trang chủ Quan trắc
      </v-chip>
    </div>
    <div class="mt-4">
      <v-card 
        flat 
        class="px-2 py-4"
        :loading="loading"
      >
        <iframe 
          class="embed-responsive-item" 
          :src="envIframe" 
          allowfullscreen 
          width="100%" 
          height="700px" 
          style="border: 0;"
          @load="load"
        />
      </v-card>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        loading: true
      }
    },
    computed: {
      ...mapState([
        'config'
      ]),
      envIframe(){
        return `${this.config.beUrl}/env-iframecors-sol`;
      }
    },
    methods: {
      load: function(){
        this.loading = false;
      }
    }
  }
</script>
<style>
  .v-progress-linear--absolute{
    z-index: 3 !important;
  }
  .env-btn-link{
    position: absolute; 
    top: 0; 
    right: 0;
  }
</style>